<template>
  <el-dialog
    title="提示"
    :visible.sync="dialogVisible"
    append-to-body
    :close-on-click-modal="false"
    width="660px"
    @close="handleClose"
  >
    <div style="margin-bottom: 20px;">
      <p style="line-height: 24px; margin-bottom: 15px; color: #E6A23C;">
        下列师傅未在【管理费群组管理】配置，如需群组归属。请在【创建结算单】前，完成【归属】操作
      </p>
      <div style="max-height: 300px; overflow-y: auto;">
        <p 
          v-for="(item, index) in installerList" 
          :key="index"
          style="line-height: 24px; margin: 5px 0;"
        >
          {{ item.name }} : {{ item.account }}
        </p>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleClose">关闭</el-button>
      <el-button type="primary" size="small" @click="handleGoToConfig">立即去配置</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "UnassignedInstallerDialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    installerList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false);
    },
    handleGoToConfig() {
      // 跳转到管理费群组管理页面
      this.$router.push('/home-admin/admin/group');
      this.handleClose();
    }
  }
};
</script>

<style scoped>
</style>

